// EXPERIMENT: psf_share_asset_ab_experiment — remove with experiment cleanup
import { useEffect } from 'react';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useShareAssetAbTreat } from '#src/app/pages/psf/shared/hooks';

/**
 * Treats psf_share_asset_ab_experiment, and fires `$exposure`, when the share page renders: the page shows the share
 * links that carry the arm. Only petitions listed in the psf_share_asset_ab FCM take part.
 */
export function useTreatShareAssetAb(): void {
	const {
		data: {
			petition: { shareAssetAb },
		},
	} = usePsfSharePageData();
	const treat = useShareAssetAbTreat(shareAssetAb);

	useEffect(() => {
		void treat();
	}, [treat]);
}
